import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from '../ui/CtaButton';
import { comparisonRows } from '../../data/comparison';
import { getCheckoutHref, getFormattedPrice } from '../../utils/offer';
export function BeforeAfter() {
  const price = getFormattedPrice();
  return <section aria-labelledby="compare-heading" className="bg-onyx" data-id="element-17" data-mp="22lkbo2b3ynh8">
      <div className="mx-auto max-w-5xl px-5 py-16 md:py-24" data-id="element-18" data-mp="2zb1n6xwrv3qu">
        <div className="mx-auto max-w-3xl text-center" data-id="element-19" data-mp="2zai8rr6byxhk">
          <h2 id="compare-heading" className="font-display text-5xl font-extrabold uppercase leading-[0.92] text-white md:text-6xl" data-id="element-20" data-mp="2ubfen1rw2bod">
            Stop improvising. <span className="text-gold" data-id="element-21" data-mp="2lbirx5p27mvy">Start coaching with a system.</span>
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-white/75" data-id="element-22" data-mp="1ev6sz2eey0zb">
            Your next 26 weeks of HYROX classes, organized and ready to teach.
          </p>
        </div>

        <div className="mt-12 overflow-hidden rounded-xl border border-white/10" data-id="element-23" data-mp="19y6lcn1x0q63">
          <div className="grid grid-cols-2" data-id="element-24" data-mp="175vu4qwvdljd">
            <p className="bg-card px-4 py-4 text-center font-display text-lg font-extrabold uppercase text-white/60 sm:text-2xl" data-id="element-25" data-mp="1c472sybfhq00">
              Without Mega Pack
            </p>
            <p className="bg-forest px-4 py-4 text-center font-display text-lg font-extrabold uppercase text-gold sm:text-2xl" data-id="element-26" data-mp="y70n5cm047f0">
              With Mega Pack
            </p>
          </div>
          <ul data-id="element-27" data-mp="ocrwyvkg0qk0">
            {comparisonRows.map(row => <li key={row.before} className="grid grid-cols-2 border-t border-white/10" data-id="element-28" data-mp="t6mp8ne46dup">
                <span className="flex items-start gap-2.5 bg-card px-4 py-5 text-base text-white/65 sm:px-6 sm:text-lg" data-id="element-29" data-mp="fezjlwya7sz9">
                  <XIcon aria-hidden="true" className="mt-1 h-4 w-4 shrink-0 text-red-400" strokeWidth={3} data-id="element-30" data-mp="jgkz7q27ald5" />
                  {row.before}
                </span>
                <span className="flex items-start gap-2.5 bg-forest/80 px-4 py-5 text-base font-semibold text-white sm:px-6 sm:text-lg" data-id="element-31" data-mp="afmwdb3i0jw5">
                  <CheckIcon aria-hidden="true" className="mt-1 h-4 w-4 shrink-0 text-cta" strokeWidth={3} data-id="element-32" data-mp="2c5u2m62xy8e4" />
                  {row.after}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-12 w-full max-w-md text-center" data-id="element-33" data-mp="239uvilnhdt0u">
          {price && <p className="mb-5 text-base text-white/75" data-id="element-34" data-mp="1yep9znxzqgda">
              26-week plan + 5 bonuses · <span className="font-bold text-white" data-id="element-35" data-mp="2v2lis6n6s7dy">{price}</span>
            </p>}
          <CtaButton href={getCheckoutHref()} fullWidth data-id="element-36" data-mp="2r2uvicwvc9e6">
            Get HYROX Mega Pack now
          </CtaButton>
        </div>
      </div>
    </section>;
}